import { useEffect } from 'react'
import { callFromJsBridgeHandler } from '.'

// Initialize immediately when module loads (before React renders)
// This ensures Android/iOS can call the bridge as soon as the script loads
if (typeof window !== 'undefined') {
  window.pixaiWebBridge = {
    postMessage: callFromJsBridgeHandler,
  }
}

export function useJsBridgeCallbackInDom() {
  useEffect(() => {
    // Re-initialize in case it was cleared
    window.pixaiWebBridge = {
      postMessage: callFromJsBridgeHandler,
    }

    return () => {
      // Don't clear on unmount to avoid breaking ongoing calls
      // window.pixaiWebBridge = {}
    }
  }, [])
}
